import { render, staticRenderFns } from "./zftz.vue?vue&type=template&id=388ae782&"
import script from "./zftz.vue?vue&type=script&lang=js&"
export * from "./zftz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports